import React from 'react';

import countries from '../helpers/countries'

const tabs = [
  "Name",
  "Contacts",
  "Address",
  "Payout information",
  "Password"
]

const payoutButtons = [
  {
    label: "Wire",
    value: "wire"
  }, {
    label: "Paypal",
    value: "paypal",
  }
]

class Component extends React.Component {

  componentWillMount() {
    if (this.props.state.tab) {
      this.setState({tab: this.props.state.tab})
    } else {
      this.setState({tab: tabs[0]})
    }
    this.props.api("profile/info");
  }

  onChange = (e) => {    
    let profile = this.props.profile;
    let { name, value } = e.target;
    if (typeof profile[name+"_original"] == "undefined") {
      profile[name+"_original"] = profile[name]  
    }    
    profile[name] = value
    this.props.changeProfile(profile)
  }

  onBlur = (e) => {
    this.onChange(e);
    let {name, value} = e.target
    this.props.api("profile/edit",{
      key: name,
      value: value
    }).then(res => {
      if (!res || !res.result) {
        let profile = this.props.profile;
        profile[name] = profile[name+"_original"]
        delete profile[name+"_original"]
        this.props.changeProfile(profile)
      } else {
        this.props.profile[name+"_original"] = value;
        let user = this.props.user;
        user[name] = value;
        this.props.changeSession(user);
      }
    })
  }

  savePassword = (e) => {
    let oldPassword = this.props.old_password || ""
    let newPassword = this.props.new_password || ""
    let retypePassword = this.props.retype_password || ""
    if (newPassword != retypePassword) {
      this.setState({passwordsInfo: "Password does not match"})
      return
    }
    if (newPassword.length < 6) {
      this.setState({passwordsInfo: "Password must be at least 6 characters"})
      return
    }

    this.setState({passwordsInfo: "Checking..."})
    this.props.api("profile/edit_password",{
      old_password: oldPassword,
      new_password: newPassword
    }).then((res)=> {
      if (!res) {
        this.setState({passwordsInfo: "Server error"})
      } else {
        if (res.result == 1) {
          this.setState({passwordsInfo: "Changed"})
        } else if (res.error == "Error: wrong password") {
          this.setState({passwordsInfo: "Incorrect old password, please try again"})
        } else {
          this.setState({passwordsInfo: "Server error"})
        }
      }
    }).catch((err)=> {
      if (err.toString() == "wrong password") {
          this.setState({passwordsInfo: "Incorrect old password, please try again"})
      } else {
        this.setState({passwordsInfo: "Server error"})
      }
    })
  }

  formGroup = (params) => {
    let { label, key, placeholder, options, type, onChange, onBlur } = params
    let value = this.props.profile[key] || "";
    return (
      <div class="form-group row">
        <label class="col-3 col-form-label">{label}</label>
        <div class="col-9">
          {!options && 
          <input 
            class="form-control" 
            type={type || "text"}
            placeholder={placeholder ? placeholder : label} 
            name={key}
            value={value} 
            onChange={onChange || this.onChange}
            onBlur={onBlur || this.onBlur}
          />
          }
          {options && 
            <select name={key} value={value} class="form-control" onChange={this.onBlur}>
              {Object.keys(options).map((key) =>
                <option key={key} value={key}>{options[key]}</option>
              )}
            </select>
          }
        </div>
      </div>
    )
  }

  changeTab = (tab) => {
    this.setState({tab})
    this.props.setState({tab})
  }

  render() {
    let isPaypal = this.props.profile.payment_method != "1";
    let fg = this.formGroup;
    let postbackSaleExample = "http://mysite.com/postback/sale?wid={wid}&subaffiliate={subaffiliate}&offer={offer}&earnings={earnings}";
    return (
      <div>
        <div class="nav-active-primary b-b b-primary">
          <ul class="nav nav-tabs">            
            {tabs.map((tab) =>
              <li key={tab} class="nav-item">
                <a class={"nav-link "+(this.state.tab == tab  ? "active" : "")} onClick={e => this.changeTab(tab)}>
                  {tab}
                </a>
              </li>
            )}
          </ul>
        </div>
        <div class="tab-content">                
            <div class="tab-pane pt-3 active">
              <div class="box">
                <div class="box-body">
                  {this.state.tab == tabs[0] && <div>
                    {fg({label: "First name", key: "firstname"})}
                    {fg({label: "Last name", key: "lastname"})}
                    {fg({label: "Traffic type", key: "traffic_type", placeholder: "Media buys, PPC, OPT-IN, Other"})}
                    {fg({label: "Website", key: "url"})}
                  </div>}
                  {this.state.tab == tabs[1] && <div>
                    {fg({label: "Email", key: "email"})}
                    {fg({label: "Company", key: "company"})}
                    {fg({label: "Skype", key: "skype"})}
                    {fg({label: "Gtalk", key: "gtalk"})}
                    {fg({label: "Yahoo", key: "yahoo"})}
                    {fg({label: "ICQ", key: "icq"})}
                    {fg({label: "Phone", key: "phone"})}
                    {fg({label: "Mobile", key: "mobile"})}
                    {fg({label: "Fax", key: "fax"})}
                  </div>}
                  {this.state.tab == tabs[2] && <div>
                    {fg({label: "Address", key: "address", required: true})}
                    {fg({label: "City", key: "city", required: true})}
                    {fg({label: "State", key: "state", required: true})}
                    {fg({label: "Country", key: "country", required: true, options: countries})}
                    {fg({label: "Zip / Postal code", key: "zip", required: true})}
                  </div>}
                  {this.state.tab == tabs[3] && <div>
                    <div class="btn-group form-group col-12">
                      <button 
                        class={"btn primary col-6 "+(isPaypal ? "" : "active")}
                        name="payment_method"
                        value="1"
                        onClick={this.onBlur}                        
                      >Wire</button>                    
                      <button 
                        class={"btn primary col-6 "+(isPaypal ? "active" : "")}
                        name="payment_method"
                        value="2"
                        onClick={this.onBlur}
                      >Paypal</button>
                    </div>
                    {!isPaypal && <div>
                      {this.formGroup({label: "Account holder", key: "wire_account_holder"})}
                      {this.formGroup({label: "Account address", key: "wire_holder_address"})}
                      {this.formGroup({label: "Account country", key: "wire_account_country"})}
                      {this.formGroup({label: "Bank name", key: "wire_bank_name"})}
                      {this.formGroup({label: "Bank city", key: "wire_bank_city"})}
                      {this.formGroup({label: "Bank country", key: "wire_bank_country"})}
                      {this.formGroup({label: "IBAN / Account No", key: "wire_iban"})}
                      {this.formGroup({label: "Swift", key: "wire_swift"})}
                      {this.formGroup({label: "Routing number", key: "routing_number"})}                      
                    </div>}                    
                    {isPaypal && this.formGroup({label: "Paypal", key: "paypal_email_adr"})}
                  </div>}
                  {this.state.tab == tabs[4] && <div>
                    {this.formGroup({label: "Old password", key: "old_password", type: "password", onBlur: ()=>{}})}
                    {this.formGroup({label: "New password", key: "new_password", type: "password", onBlur: ()=>{}})}
                    {this.formGroup({label: "Retype password", key: "retype_password", type: "password", onBlur: ()=>{}})}
                    <div>
                      <button class="btn warning" onClick={this.savePassword}>Save</button>
                      <label class="ml-3">{this.state.passwordsInfo || ""}</label>
                    </div>
                  </div>}
                </div>
              </div>
            </div>
        </div>
      </div>
    )
  }
}

import api from '../actions/api'
import setState from '../actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {  
  let apiState = state.api.profile_info || state.api.initial;
  let editApiState = state.api.profile_edit || state.api.initial;
  return {
    ...apiState.data,
    initial: apiState.initial,
    loading: apiState.loading,
    profile: apiState.data,
    editLoading: editApiState.loading,
    state: state.state.profile || state.state.initial,
    user: state.session.user
  }
}, {
  api, 
  setState: setState("profile"),
  changeProfile: function(data) {
    return function(dispatch) {
      dispatch({
        type: "api_success",
        key: "agent_profile",
        manual: true,
        data: data
      })
    }
  },
  changeSession: function(data) {
    return function(dispatch) {
      dispatch({
        type: "api_success",
        key: "auth_login",
        manual: true,
        data: {
          user: data
        }
      })
    }
  }  
})(Component)  